<template>
    <div class="page bg-gray">
        <backTitleBar></backTitleBar>
        <div class="pd-025">
            <div class="flex-center bg-fff pd-25 row-item mt-20 click" @click="$router.push({name: 'shopBaseInfo'})">
                <div class="alifont icon-jibenxinxi color-main"></div>
                <div class="fs-32 color-333 text">基本信息</div>
            </div>
            <div class="flex-center bg-fff pd-25 row-item mt-20 click" @click="$router.push({name: 'shopQualifyInfo'})">
                <div class="alifont icon-zizhixinxi" style="color:#FFB419"></div>
                <div class="fs-32 color-333 text">资质信息</div>
            </div>
            <div class="flex-center bg-fff pd-25 row-item mt-20 click" @click="$router.push({name: 'shopBankInfo'})">
                <div class="alifont icon-yinhangkaxinxi" style="color: #4483FF"></div>
                <div class="fs-32 color-333 text">银行卡信息</div>
            </div>
            <div class="flex-center bg-fff pd-25 row-item mt-20 click" @click="$router.push({name: 'shopMainInfo'})">
                <div class="alifont icon-dianpupeizhi" style="color: #FF8151"></div>
                <div class="fs-32 color-333 text">店铺配置</div>
            </div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "index",
        components:{backTitleBar},
    }
</script>

<style scoped lang="scss">
    .row-item{
        border-radius: .12rem;
        .alifont{
            font-size: .68rem;
        }
        .text{
            font-weight: bold;
            margin-left: .24rem;
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?3727e0c2